import React from 'react';

const ZENOTI_GIFTCARD_URL = 'https://cutiepiewaxbar.zenoti.com/webstoreNew/giftcards';

function GiftCardPage({ onBackToBooking }) {
  return (
    <div className="step-content gc2-page">
      <div className="gc2-landing">
        <img
          src="/giftcard-hero.jpg"
          alt="Cutie Pie Wax Bar gift card"
          className="gc2-landing-hero"
        />
        <h2 className="gc2-landing-title">Gift Cards</h2>
        <p className="gc2-landing-subtitle">
          Send the perfect gift — choose an amount or a specific service for someone special.
        </p>
        <a
          href={ZENOTI_GIFTCARD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="auth-button gc2-launch-btn"
        >
          Purchase a Gift Card
        </a>
        <button className="gc2-back-link" onClick={onBackToBooking}>
          &larr; Back to Booking
        </button>
      </div>
    </div>
  );
}

export default GiftCardPage;
